function Intro({ title }) {
  return (
    <div className='article intro'>
      <div className='container'>
        <h2>
          <div dangerouslySetInnerHTML={{ __html: title }} />
          {/* <span dangerouslySetInnerHTML={{ __html: title }} /> */}
        </h2>
        <div className='content'>
          <p>“润”（以及“润学”）是近年来在中国大陆兴起的，研究如何逃离中国并移民到更自由、更发达国家的网络迷因。在严厉的新冠疫情封控政策之下，特别是上海封城之后，“润”在大众文化中变成了一门显学。</p>
          <p>然而在润学风靡之前，这股外逃的势能，早已在中国近十年来的社会现实中酝酿。正如本特别企划中评论作者钟山所说，“对于未曾亲历中国曾经的政治灾难、习惯了改革开放的设定的新一代来说，中国在过去十年变得越来越陌生，政治极权、经济失速、社会溃败、文化保守，这些方面的变化都以极端事件的方式出现，不同阶级的人都感受到不同程度的伤害。不仅仅是日常焦虑的中产阶级，普通的工人农民都能察觉到身边出现的困境和危机。”</p>
          <p>而曾经沉浸在“大国崛起”自豪感里的年轻人，也不得不面临一个竞争越发激烈、分配深刻不公的社会。当改革开放的黄金时代和人口红利期都已远去，他们的发展前景暗淡，个人自由又严重受限，被迫面对残酷的现实。</p>
          <p>疫情期间，诸事停摆，公权与私权之间矛盾凸显，当局各种倒行逆施的操作无差别地施加给各个群体巨大的痛苦。人们普遍失去了安全感，焦虑于不确定的未来。然而，在密不透风的刚性维稳和数字监控下，很多人意识到自己无力改变大环境，只能寻求自救的出口。</p>
          <p>“润”预示着中国第四次移民潮的到来，它仿佛是当代不合作的中国人唯一的退出机制，是一场个人对国家的消极反抗。“润”既是社会的无力溃散，也是个人改变命运的勇敢一搏。在留下与离开之间，有太多的矛盾、取舍和拉扯，足以反映出复杂的时代景象。</p>
          <p>离开自己的国家究竟意味着什么？只有那些正跋涉在离散之路上的人才深有体会。正如水里的鱼儿难以察觉到水的重要，生活在熟悉的社会里的人也会把周围的条件视为理所当然。然而，当他们离开了陪伴自己从小到大的亲人、朋友、社群和社会所构建的支持系统，便会进入仿佛赤身裸体与这个世界碰撞的状态。</p>
          <p>润的难度很大程度上取决于一个人有多少的“特权”和资源。在润的道路上，每个人所遭遇的困境以及相应的挣扎，都和他们的阶层、家庭、族裔、性别、学历、工作资历等各种身份背景息息相关，弱势者在这个过程里会暴露更多脆弱，也更容易受到剥削或陷入困境。</p>
          <p>润并不是一个简单的逃离母国、拥抱自由的过程，更多的是被迫、无奈，是孤注一掷、丢盔弃甲和漫长的挣扎。在和有关移民的各种体制交际时，很多人都会有类似于“被碾压”、“被钳制”的痛苦体验。但以此为契机，他们也将不断进行对自我、对外界的反思和审视，尽力重新获取主动性。</p>
          <p>润是一场永远在路上的修行，但是这场修行的尽头，不应止于个体获得救赎。正如钟山在文章结尾所说，中国问题是润学的触发点，但也会是落脚点。</p>
          <p>“如果中国无法走向政治开放与自由的道路，那么润的议题就会一直存在，走在这条道路上的人会不断实践他们肉身或精神上的逃离和叛逆。最终，他们之中一定会有人找到反击的途径。”</p>
          <p>通过挖掘这些“润者”的形象和故事，歪脑希望和读者一起，看见他们，看见彼此，去提出对时代、对体制的质问，帮助个体寻找“反击的途径”。</p>
        </div>
      </div>
    </div>
  );
}

export default Intro;
